import { render, staticRenderFns } from "./TaskNew.vue?vue&type=template&id=53891203&scoped=true&"
import script from "./TaskNew.vue?vue&type=script&lang=js&"
export * from "./TaskNew.vue?vue&type=script&lang=js&"
import style0 from "./TaskNew.vue?vue&type=style&index=0&id=53891203&prod&lang=scss&"
import style1 from "./TaskNew.vue?vue&type=style&index=1&id=53891203&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53891203",
  null
  
)

export default component.exports